import { call, put, takeLatest } from 'redux-saga/effects'
import {
    GetAllAnnouncement_API,
    ViewAnnouncement_API,
    AddAnnouncement_API,
    UpdateAnnouncement_API,
    DeleteAnnouncement_API
} from '../../../Config/Api';
import { createNotification } from '../../../Config/NotificationToast';
import { logOut, encryptUrlData } from "../../../utils/Helper";
import { instance } from "../../auth/axiosInstance";
import { getDataFromFirebase } from '../../../Config/commonFirebaseImage';
import { deleteObject, getDownloadURL, getStorage, ref, uploadBytesResumable } from 'firebase/storage';
import { app } from '../../../firebase';
const storage = getStorage(app);
const metadata = { cacheControl: 'public, no-cache' };

export default function* announcementSaga() {
    yield takeLatest('GET_ANNOUNCEMENT_LIST', getAnnouncementList);
    yield takeLatest('GET_ANNOUNCEMENT_DETAILS', getAnnouncementDetails);
    yield takeLatest('ADD_ANNOUNCEMENT', addAnnouncement);
    yield takeLatest('UPDATE_ANNOUNCEMENT', updateAnnouncement);
    yield takeLatest('DELETE_ANNOUNCEMENT', deleteAnnouncement);
}

const getAnnouncementListApi = async (URL) => {
    try {
        const response = await instance.get(URL);
        return response;
    } catch (errors) {
        console.log("errors", errors)
        if (
            errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}
function* getAnnouncementList(action) {
    const URL = `${GetAllAnnouncement_API}?page=${action.data.pageNo}&limit=${action.data.pageSize}${(action.data.filter_text) ? `&filter_text=${action.data.filter_text}` : ""}`
    try {
        const response = yield call(getAnnouncementListApi, URL);
        if (response.statusCode === 200) {
            for (let item of response.data.data) {
                if (item?.media) {
                    item.media_url = yield getDataFromFirebase(item.media);
                }
            }
            yield put({ type: 'GET_ANNOUNCEMENT_LIST_SUCCESS', response: response.data });
        } else {
            if (response.statusCode === 401) {
                logOut('error', response.message)
            } else {
                createNotification('error', response.message);
                yield put({ type: 'GET_ANNOUNCEMENT_LIST_FAILURE', message: response.message });
            }
        }
    } catch (e) {
        yield put({ type: 'GET_ANNOUNCEMENT_LIST_FAILURE', message: "No data found" });
    }
}


const getAnnouncementApi = async (URL) => {
    try {
        const response = await instance.get(URL);
        return response;
    } catch (errors) {
        console.log("errors", errors)
        if (
            errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}
function* getAnnouncementDetails(action) {
    const URL = `${ViewAnnouncement_API}?id=${action.data.id}`
    try {
        const response = yield call(getAnnouncementApi, URL);
        if (response.statusCode === 200) {
            let media_url = yield getDataFromFirebase(response.data.media);
            response.data.media_url = media_url
            yield put({ type: 'GET_ANNOUNCEMENT_DETAILS_SUCCESS', response: response.data });
        } else {
            if (response.statusCode === 401) {
                logOut('error', response.message)
            } else {
                createNotification('error', response.message);
                yield put({ type: 'GET_ANNOUNCEMENT_DETAILS_FAILURE', message: response.message });
            }
        }
    } catch (e) {
        yield put({ type: 'GET_ANNOUNCEMENT_DETAILS_FAILURE', message: "No data found" });
    }
}


const addAnnouncementApi = async (data) => {
    try {
        const response = await instance.post(AddAnnouncement_API, {data});
        return response;
    } catch (errors) {
        console.log("errors", errors);
        if (errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}
function* addAnnouncement(action) {
    try {
        const filePath = `/offers/${Date.now()}-${action.data.new_media.name?.replace(/\s/g, '')}`;
        const fileRef = ref(storage, filePath);
        const uploadTask = uploadBytesResumable(fileRef, action.data.new_media, metadata);
    
        const uploadFile = () => {
            return new Promise((resolve, reject) => {
                uploadTask.on('state_changed',
                    (snapshot) => {
                        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        action.data?.setProgress?.(progress);
                    },
                    (error) => {
                        reject(""); 
                    },
                    async () => {
                        try {
                            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                            resolve(downloadURL); 
                        } catch (error) {
                            reject(""); 
                        }
                    }
                );
            });
        };
        const downloadURL = yield call(uploadFile);
    
            
        const BODY = {
            "title": action.data.title || '',
            "description": action.data.description || '',
            "media": filePath || '',
            "media_type": "image",
            "media_thumbnail": "image",
            "redirect_lable": action.data.redirect_lable || '',
            "redirect_page": action.data.redirect_page || "",
            "is_redirect_action": action.data.is_redirect_action || 0,
            "visible_to": action.data.visible_to || '0',
            "visible_program_type": action.data.visible_program_type || ''
        }
        const data = BODY;
        const response = yield call(addAnnouncementApi, data);
        if (response.statusCode === 200) {
            yield put({ type: 'ADD_ANNOUNCEMENT_SUCCESS', response: response.data });
            action.data?.onSuccessCallback?.()
            createNotification('success', response.message);
        } else {
            if (response.statusCode === 401) {
                logOut('error', response.message)
            } else {
                createNotification('error', response.message);
                yield put({ type: 'ADD_ANNOUNCEMENT_FAILURE', message: response.message });
            }
        }
    } catch (e) {
        yield put({ type: 'ADD_ANNOUNCEMENT_FAILURE', message: e.message });
    }
}


const updateAnnouncementApi = async (data) => {
    try {
        const response = await instance.put(UpdateAnnouncement_API, {data});
        return response;
    } catch (errors) {
        console.log("errors", errors);
        if (errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}
function* updateAnnouncement(action) {
    
    try {
        let filePath=action.data.media
            if(action.data.new_media){
                const deleteFileRef = ref(storage, action.data.media);
                    deleteObject(deleteFileRef)
                    .then(() => {
                    })
                    .catch((error) => {
                        createNotification('error', "Error in deleting file");
                    });

                filePath = `/offers/${Date.now()}-${action.data.new_media.name?.replace(/\s/g, '')}`;
                const fileRef = ref(storage, filePath);
                const uploadTask = uploadBytesResumable(fileRef, action.data.new_media, metadata);
        
                const uploadFile = () => {
                    return new Promise((resolve, reject) => {
                        uploadTask.on('state_changed',
                            (snapshot) => {
                                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                action.data?.setProgress?.(progress);
                            },
                            (error) => {
                                reject(""); 
                            },
                            async () => {
                                const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                                resolve(downloadURL);
                              }
                        );
                    });
                };
                const downloadURL = yield call(uploadFile);

            }
    
        const BODY = {
            "id" : action.data.id, 
            "title": action.data.title || '',
            "description": action.data.description || '',
            "media": filePath || '',
            "media_type": "image",
            "media_thumbnail": "image",
            "redirect_lable": action.data.redirect_lable || '',
            "redirect_page": action.data.redirect_page || "",
            "is_redirect_action": action.data.is_redirect_action || 0,
            "visible_to": action.data.visible_to || '0',
            "visible_program_type": action.data.visible_program_type || ''
        }

        const data = BODY;
        const response = yield call(updateAnnouncementApi, data);
        if (response?.statusCode === 200) {
            yield put({ type: 'ADD_ANNOUNCEMENT_SUCCESS', response: response.data });
            createNotification('success', response.message);
            action.data?.onSuccessCallback?.()
        } else {
            if (response?.statusCode === 401) {
                logOut('error', response.message)
            } else {
                yield put({ type: 'ADD_ANNOUNCEMENT_FAILURE', message: response?.message });
            }
        }
    } catch (e) {
        yield put({ type: 'ADD_ANNOUNCEMENT_FAILURE', message: e.message });
    }
}


const deleteAnnouncementApi = async (url) => {
    
    try {
        const response = await instance.delete(url);
        return response;
    } catch (errors) {
        console.log("errors", errors)
        if (errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}
function* deleteAnnouncement(action) {
    const url = `${DeleteAnnouncement_API}/${action.data.id}`;

    try {
        if(action.data.doc_path){
            const fileRef = ref(storage, action.data.doc_path);
            deleteObject(fileRef)
            .then(() => {
            })
            .catch((error) => {
                createNotification('error', "Error in deleting file");
            });

        }
        const response = yield call(deleteAnnouncementApi, url);
        const deleteGuestRes = response;

        if (deleteGuestRes.statusCode === 200) {
            yield put({ type: 'DELETE_ANNOUNCEMENT_SUCCESS', deleteTeamMember: deleteGuestRes });
            action.data?.onSuccessCallback?.()
            createNotification('success', deleteGuestRes.message);

            // const listURL = `${GetAllAnnouncement_API}?page=${action.data.pageNo}&limit=${action.data.pageSize}${(action.data.filter_text) ? `&filter_text=${action.data.filter_text}` : ""}`
            // const listResponse = yield call(getAnnouncementListApi, listURL);
            // yield put({ type: 'GET_ANNOUNCEMENT_LIST_SUCCESS', response: listResponse.data });

        } else {
            if (deleteGuestRes.statusCode === 401) {
                logOut('error', deleteGuestRes.message)
            } else {
                createNotification('error', deleteGuestRes.message);
                yield put({ type: 'DELETE_ANNOUNCEMENT_FAILURE', message: deleteGuestRes.message });
            }
        }
    } catch (e) {
        yield put({ type: 'DELETE_ANNOUNCEMENT_FAILURE', message: e.message });
    }
}